import CrudApiClient from './crudapiclient';
import { GATEWAY_API_URL } from '@admin-panel/config/env';
import { MetaQuery } from '@refinedev/core';

class DeliveryChallanCommentAPIClient extends CrudApiClient {
  constructor() {
    super(GATEWAY_API_URL + '/deliverychallan/:deliveryChallanId/comment');
  }

  resolveParameterizedUrlVariables(meta: MetaQuery | undefined) {
    return this.baseURL?.replace(':deliveryChallanId', meta?.deliveryChallanId);
  }
}

export default DeliveryChallanCommentAPIClient;
